import * as React from 'react';
import questions from './questions.json';
import QuestionTemplate from './QuestionTemplate';

export default function ClientHistory() {
  return (
    <div className="question-container">
      {Object.entries(questions.client_history).map(([key, value], index) => (
        <QuestionTemplate
          key={key}
          identifier={key}
          type={value.type}
          label={value.label}
          event={'client_history'}
        />
      ))}
    </div>
  );
}
